// extracted by mini-css-extract-plugin
export default {"icons":"MSTTR_icons__Bvb38","editBtn":"MSTTR_editBtn__NAjVY","deleteBtn":"MSTTR_deleteBtn__hhnVo"};